import {useQuery} from "@tanstack/react-query";
import {readFormula} from "../../../../../api/inventory/AnalyzeApi";

export const useReadFormula = () => {
    const {data} = useQuery({
        queryKey: ["readFormula"],
        queryFn: async () => await readFormula(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
